// extracted by mini-css-extract-plugin
module.exports = {"container":"PanelGachaMinting_container__lHlG9","description":"PanelGachaMinting_description__6W1M2"};